module.exports = __webpack_public_path__ + "static/media/Rusty Payton Headshot.eb4879f5.jpeg";